import { PublicCallback } from 'globals/types';
import { updateSession } from 'core_main/api/sessions';
import { EndConversationParameters } from './types';
import { CUSTOMER_ENDED_LOCK_REASON } from './constants';
import { createEndConversationCallbackResponse } from './helpers';

export const endConversation = (
  parameters: EndConversationParameters,
  cb?: PublicCallback,
) => {
  const sessionId = parameters?.conversationId;

  return updateSession(sessionId, {
    locked: true,
    lockReason: CUSTOMER_ENDED_LOCK_REASON,
  })
    .then((res) => {
      const callbackResponse = createEndConversationCallbackResponse(res.data);
      if (typeof cb === 'function') {
        cb(callbackResponse);
      }
    })
    .catch((error) => {
      if (typeof cb === 'function') cb(null, error);
      console.error('Failed to end conversation', error);
    });
};
